import React from 'react'
import PropTypes from 'prop-types'
import clsx from 'clsx'
import ResponsiveImage from 'components/images/responsive-image'
import { PICKUP_LOCATION as CON } from 'pages/pomelo-pickup/const'
import { hasLocizeTranslation } from 'lib/utils/locize'
import env from 'config/env'
import Typo from 'constants/typography'
import Icon from 'components/common/icon'
import ICONS, { ICON_SIZE } from 'components/common/icon/const'
import { isAppWebView } from 'lib/utils/common/commonUtils'
import styles from './styles.scss'

class LocationDetails extends React.PureComponent {
  getNearestBtsData(value) {
    if (!value) {
      return null
    }

    return value.split(', ')
  }

  renderHours = (hours) => {
    const { isPhone } = this.props
    if (!hours) {
      return null
    }

    const infoDescClassName = isPhone ? Typo.caption : Typo.body2
    const [day, ...time] = hours.split(':')
    let parsedTime = '-'

    if (time) {
      parsedTime = time.toString().split(',').join(':')
    }

    return (
      <div className="pickup-locale-info__hours" key={hours}>
        <span className={infoDescClassName}>{day || '-'}</span>
        <span className={infoDescClassName}>{parsedTime}</span>
      </div>
    )
  }

  renderBts = (bts) => {
    const { isPhone } = this.props
    const infoDescClassName = isPhone ? Typo.caption : Typo.body2

    return (
      <p key={`bts_${bts}`} className={infoDescClassName}>
        {bts}
      </p>
    )
  }

  renderGetDirection() {
    const {
      location: { latitude, longitude },
      t,
    } = this.props

    if (!latitude || !longitude) {
      return null
    }

    return (
      <a
        href={`https://maps.google.com/maps?daddr=${latitude},${longitude}`}
        rel="noopener noreferrer"
        target="_blank"
        className={clsx(Typo.overline, 'pickup-locale-info__cta')}
      >
        {hasLocizeTranslation(t, CON.getDirectionKey, CON.getDirection)}
      </a>
    )
  }

  renderMap(location) {
    return (
      <ResponsiveImage
        className="pickup-locale-info__map"
        src={`${env.IMG_HOST}${location?.images?.floormap?.main}`}
      />
    )
  }

  render() {
    const {
      isPhone,
      location,
      t,
      isFixedButton,
      fromPickupDetailModal,
      hideMap,
    } = this.props

    const {
      address1,
      address2,
      nearest_bts,
      hours,
      phone,
      latitude,
      longitude,
    } = location

    const btsData = this.getNearestBtsData(nearest_bts)

    const buttonContainerClassName = clsx('pickup-locale__button-container', {
      'pickup-modal_button-container': fromPickupDetailModal,
      'fixed-button-container': isFixedButton,
    })

    const wrapperContainerClassName = clsx('pickup-locale-info__wrapper', {
      'extra-padding-area': fromPickupDetailModal,
    })
    const shouldRenderWebViewElem = isPhone && isAppWebView()
    const infoTitleClassName = `pickup-locale-info__title ${
      isPhone ? Typo.subtitle2 : Typo.subtitle1
    }`
    const infoDescClassName = `pickup-locale-info__desc ${
      isPhone ? Typo.caption : Typo.body2
    }`

    return (
      <React.Fragment>
        <style jsx>{styles}</style>
        {shouldRenderWebViewElem && (
          <div className="pickup-locale__webview">
            <Icon src={ICONS.pickupPhone} size={ICON_SIZE.medium} />
            <span className="pickup-locale__webview__span">
              {hasLocizeTranslation(t, CON.callKey, CON.call)}
            </span>
            <span className="pickup-locale__webview__phone">{phone}</span>
          </div>
        )}
        <div className="test">
          <section className={wrapperContainerClassName}>
            {hours?.length > 0 && (
              <div
                className="pickup-locale-info__part"
                style={{ gridArea: 'hours' }}
              >
                <span className={infoTitleClassName}>
                  {hasLocizeTranslation(t, CON.hoursKey, CON.hours)}
                </span>
                {hours.map(this.renderHours)}
              </div>
            )}
            {(Boolean(address1) || Boolean(address2)) && (
              <div
                className="pickup-locale-info__part"
                style={{ gridArea: 'location' }}
              >
                <span className={infoTitleClassName}>
                  {hasLocizeTranslation(t, CON.locationKey, CON.location)}
                </span>
                {Boolean(address1) && (
                  <p className={infoDescClassName}>{address1}</p>
                )}
                {Boolean(address2) && (
                  <p className={infoDescClassName}>{address2}</p>
                )}
                {!isPhone && this.renderGetDirection()}
              </div>
            )}
            {!isPhone && (
              <React.Fragment>
                <div
                  className="pickup-locale-info__part"
                  style={{ gridArea: 'contact' }}
                >
                  <span className={infoTitleClassName}>
                    {hasLocizeTranslation(t, CON.contactKey, CON.contact)}
                  </span>
                  <p className={infoDescClassName}>{phone}</p>
                </div>
                {!hideMap && (
                  <div
                    className="pickup-locale-info__part map-part"
                    style={{ gridArea: 'map' }}
                  >
                    {this.renderMap(location)}
                  </div>
                )}
              </React.Fragment>
            )}
            {btsData && btsData.length > 0 && (
              <div
                className="pickup-locale-info__part"
                style={{ gridArea: 'closest' }}
              >
                <span className={infoTitleClassName}>
                  {hasLocizeTranslation(t, CON.closestKey, CON.closest)}
                </span>
                {btsData.map(this.renderBts)}
              </div>
            )}
          </section>
          {isPhone && (
            <div className={buttonContainerClassName}>
              {Boolean(latitude) && Boolean(longitude) && (
                <a
                  href={`https://maps.google.com/maps?daddr=${latitude},${longitude}`}
                  rel="noopener noreferrer"
                  target="_blank"
                  className="plbc-btn"
                >
                  <Icon src={ICONS.pomeloPickupUSP} className="icon" />
                  <span className={Typo.button}>{t('directions')}</span>
                </a>
              )}
              {phone && (
                <a href={`tel:${phone}`} className="plbc-btn phone">
                  <Icon src={ICONS.pickupPhone} className="icon" />
                  <span className={Typo.button}>{t('call')}</span>
                </a>
              )}
            </div>
          )}
        </div>
      </React.Fragment>
    )
  }
}

LocationDetails.defaultProps = {
  location: null,
  isFixedButton: false,
  fromPickupDetailModal: false,
  hideMap: false,
}

LocationDetails.propTypes = {
  isPhone: PropTypes.bool.isRequired,
  location: PropTypes.shape({
    latitude: PropTypes.number,
    longitude: PropTypes.number,
    address1: PropTypes.string,
    address2: PropTypes.string,
    hours: PropTypes.arrayOf(PropTypes.string),
    nearest_bts: PropTypes.string,
    phone: PropTypes.string,
  }),
  t: PropTypes.func.isRequired,
  isFixedButton: PropTypes.bool,
  fromPickupDetailModal: PropTypes.bool,
  hideMap: PropTypes.bool,
}

export { LocationDetails }
export default LocationDetails
